<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>
        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages" >
                    <section v-for="airedejeux in tourisme" :key="airedejeux.id">
                        <div class="Fiche" v-if="airedejeux.type == 'Aire de jeux'">
                            
                            <div class="Infos Contact">
                                <h2>{{airedejeux.titre}}</h2>
                                <a :href="airedejeux.lien_adresse">{{airedejeux.adresse}}</a>
                                <p class="paragraphe" v-html="airedejeux.description"></p>
                                <router-link to="/en-images" v-for="album in listeAlbums" :key="album.id">
                                    <div v-for="albumMonu in airedejeux.album" :key="albumMonu.ID">
                                        <div class="pochette-Album" v-if="album.id == albumMonu.ID">
                                            <div class="derniereSlide">
                                                <img :src="album.images[2].url" alt="ArretBusNangis">
                                            </div>
                                            <div class="secondeSlide">
                                                <img :src="album.images[1].url" alt="ArretBusNangis">
                                            </div>
                                            
                                            <div class="premiereSlide">
                                                <img :src="album.images[0].url" alt="ArretBusNangis">
                                            </div>
                                            <div class="Titre-Album">
                                                <h5>{{album.titre_album}}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                            <div class="arret-bus">
                                <div class="contenu-droit-page" v-if="airedejeux.lien_adresse_iframe != ''">
                                    <iframe :src="airedejeux.lien_adresse_iframe" height="100%" width="100%"></iframe>
                                </div>
                                <div class="contenu-droit-page">
                                    <img :src="airedejeux.image" height="100%" width="100%">
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'Aire-de-jeux',
    data () {
        return{
            tourisme:{
                id: 0,
                type: null,
                titre: null,
                descritption: null,
                image: null,
                adresse: null,
                lien_adress: null,
                lien_adresse_iframe: null,
                descritption: null, 
                album: {
                    ID: 0
                }
            },
            listeAlbums:{
                id:0,
                titre_album: null,
                date_de_debut:null,
                date_de_fin: null,
                mots_cles:{
                    term_id:0,
                    name:null
                },
                images:{
                    id: 0,
                    url: null,
                    title: null
                }
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
        axios.get(param.host+'tourisme/v1/listeTourisme')
        .then(response =>{
        this.tourisme = response.data;
            console.log('tourisme', this.tourisme)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'album/v1/listeAlbums')
        .then(response =>{
        this.listeAlbums = response.data;
            console.log('listeAlbums', this.listeAlbums)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Aires de jeux'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Aire-de-jeux.vue